import { render, staticRenderFns } from "./ListaPago.vue?vue&type=template&id=4b6915af"
import script from "./ListaPago.vue?vue&type=script&lang=js"
export * from "./ListaPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports